<template>
  <div class="login-container">
    <div class="content">
      <!-- Logo -->
      <div class="logo">
        <img src="./img/logo1.png"/>
      </div>

      <!-- Title -->
      <h1 class="title">SIGN UP OR LOGIN TO WEDIO</h1>

      <!-- Buttons -->
      <div class="buttons">
        <!-- Google Button -->
        <button class="auth-button" @click="handleGoogleLogin">
          <svg v-show="!loading" width="24" height="24" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span> {{ loading ? 'loading...' : 'Continue with Google' }} </span>
        </button>

        <!-- Facebook Button -->
        <!-- <button class="auth-button" @click="handleFacebookLogin">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#1877F2">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
          <span>Continue with Facebook</span>
        </button> -->

        <!-- Apple Button -->
        <!-- <button class="auth-button" @click="handleAppleLogin">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          <span>Continue with Apple</span>
        </button> -->

        <!-- Email Button -->
        <!-- <button class="auth-button" @click="handleEmailLogin">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00d4ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
          </svg>
          <span>Continue with Email</span>
        </button> -->
      </div>

      <!-- Footer Text -->
      <div class="footer-text">
        <p>
          By signing into wedio, you agree to our 
          <a href="#">Terms of Service</a> and 
          <a href="#">Privacy Policy</a>.
        </p>
      </div>

      <!-- Help Link -->
      <div class="help-link">
        <a href="#">Having trouble signing in?</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core'
import { GoogleSignIn } from '@capawesome/capacitor-google-sign-in'

export default {
  name: 'AudiomackLogin',
    data() {
    return {
      loading:false,
    }
  },
  methods: {
    handleGoogleLogin() {
      if(this.loading) return
      this.loading = true
      // Redirect to Google OAuth — the backend /auth/google endpoint handles the rest
      //const platform = Capacitor.isNativePlatform() ? 'android' : 'web'
      if(Capacitor.isNativePlatform() ) this.signInWithGoogle()
      else  window.location.href = this.$store.state.baseUrl+"auth/google"
    },
    async signInWithGoogle () {

      try {
        await GoogleSignIn.initialize({
          clientId: this.$store.state.webClientId,
        })

        const result = await GoogleSignIn.signIn()
        
        // Prefer serverAuthCode, fall back to idToken
        const { serverAuthCode, idToken } = result
      
        const res = await this.$axios.post('/auth/google/mobile',{ serverAuthCode, idToken})
  
        const {accessToken, isUserExist, userId} = await res.data

        this.$router.push(`/birthInfos/${accessToken}/${isUserExist}/${userId}`)
      } catch (err) {
        //alert('Google Sign-In error:'+err)
        console.error('Google Sign-In error:', err)
        this.loading = false
      }
    }
  },
  mounted() {
    const accessToken = localStorage.getItem("access_token")
    if(accessToken) this.$router.push('/home')
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-container {
  position: absolute;
  left: 0px;
  top:0px;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: linear-gradient(135deg, rgb(10, 14, 38) 0%, rgb(26, 18, 48) 50%, rgb(13, 27, 42) 100%);
  /*background: linear-gradient(135deg, rgb(14, 14, 14) 0%, rgb(26, 26, 26) 50%, rgb(30, 30, 30) 100%);*/
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 20000;
}

.content {
  width: 100%;
  max-width: 450px;
}

.logo {
  text-align: center;
  margin-bottom: 40px;
}

.logo > img {
  width: 260px;
  max-width: 60%;
}

.title {
  color: #e0f7ff;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  letter-spacing: 0.5px;
  text-shadow: 0 0 20px rgba(0, 212, 255, 0.5);
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.auth-button {
  width: 100%;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.1);
  color: #e0f7ff;
  font-size: 16px;
  padding: 16px 24px;
  border-radius: 0.6em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.auth-button:hover {
  background: rgba(30, 41, 59, 1);
  border-color: rgba(0, 212, 255, 0.5);
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
  transform: translateY(-2px);
}

.auth-button svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.footer-text {
  margin-top: 40px;
  text-align: center;
  font-size: 14px;
  color: #94a3b8;
  line-height: 1.6;
}

.footer-text a {
  color: #00d4ff;
  text-decoration: none;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.footer-text a:hover {
  text-decoration: underline;
  text-shadow: 0 0 15px rgba(0, 212, 255, 0.5);
}

.help-link {
  margin-top: 24px;
  text-align: center;
}

.help-link a {
  color: #00d4ff;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.help-link a:hover {
  text-decoration: underline;
  text-shadow: 0 0 15px rgba(0, 212, 255, 0.5);
}

@media (max-width: 480px) {
  .title {
    font-size: 20px;
  }

  .auth-button {
    font-size: 15px;
    padding: 14px 20px;
  }
}
</style>